import { useMemoizedFn } from 'ahooks';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxRadioProps } from 'components/RevxRadio';
import { useEffect, useState } from 'react';
import { ConfigSvcProps } from '..';
import CommonJobSvcBorder from '../common/CommonJobSvcBorder';
import CommonJobSvcCotainer from '../common/CommonJobSvcCotainer';
import CommonJobSvcInstructions from '../common/CommonJobSvcInstructions';
import CommonJobSvcMessage from '../common/CommonJobSvcMessage';
import CommonJobSvcName from '../common/CommonJobSvcName';
import CommonJobSvcOption from '../common/CommonJobSvcOption';
import CommonJobSvcSpec from '../common/CommonJobSvcSpec';
import CommonQuantityPerBundle from '../common/CommonQuantityPerBundle';
import { useHideSvc } from '../hook/useHideSvc';
import { useHideSvcContainer } from '../hook/useHideSvcContainer';

const CarbonlessAdhesive = (props: ConfigSvcProps) => {
  const { formCache, form, jobOptionSvc, isRequired } = props;
  const hideSvc = useHideSvc(props);
  const hideSvcContainer = useHideSvcContainer(props);
  const [disabledOption, setDisabledOption] = useState<string>('');

  useEffect(() => {
    // if (!formCache?.[id]) {
    //   form.resetFields();
    //   form.setFieldsValue(formCache);
    // }
    if (formCache?.[39]?.name?.includes('Padding Adhesive')) {
      setDisabledOption(formCache[39]?.['Padding Edge']);
      const formData = form.getFieldsValue();
      if (
        formCache[38]?.['Adhesive Edge'] === formCache[39]?.['Padding Edge'] &&
        !isRequired
      ) {
        formData[38]['Adhesive Edge'] = jobOptionSvc.options
          ?.find((option) => {
            return option.label === 'Adhesive Edge';
          })
          ?.values.find((item) => item !== disabledOption);
      }
      // formData[38]['quantityPerBundle'] = spec.pageCount;
      form.setFieldsValue(formData);
    } else {
      setDisabledOption('');
    }
    // eslint-disable-next-line
  }, [formCache, disabledOption, form, isRequired, jobOptionSvc.options]);

  const customerRadioProps = useMemoizedFn(
    (
      labelArr: string[],
      disabled?: boolean,
      label?: string
    ): RevxRadioProps => {
      return {
        disabled: disabled,
        outSideRevxLayoutProps: {
          align: 'top',
          justify: 'left',
          wrap: 'wrap',
          className: 'jobconfig-jobOption-content-outSideOption-default',
          style: {
            paddingBottom: 0,
            marginTop: 8,
          },
        },
        inSideRevxLayoutProps: {
          align: 'top',
          justify: 'left',
          className: 'jobconfig-jobOption-content-inSideOption-default',
          style: {
            marginRight: 31,
          },
        },
        options:
          labelArr?.map((item) => {
            return {
              value: item,
              children: <span>{item}</span>,
              disabled:
                label === 'Adhesive Edge' &&
                disabledOption === item &&
                !isRequired,
            };
          }) || [],
      };
    }
  );

  return (
    <>
      <div style={hideSvc}>
        <RevxFlexLayout align="top" justify="justify-start">
          <CommonJobSvcName {...props} />
          <div>
            <CommonJobSvcCotainer {...props}>
              <CommonJobSvcSpec {...props} disabled={hideSvcContainer} />
              <CommonJobSvcOption
                customerRadioProps={customerRadioProps}
                {...props}
                disabled={hideSvcContainer}
              />
              <CommonQuantityPerBundle
                {...props}
                // show={true}
                disabled={hideSvcContainer || Boolean(disabledOption)}
              />
              <CommonJobSvcInstructions
                {...props}
                disabled={hideSvcContainer}
              />
              <CommonJobSvcMessage {...props} disabled={hideSvcContainer} />
            </CommonJobSvcCotainer>
          </div>
        </RevxFlexLayout>
        <CommonJobSvcBorder />
      </div>
    </>
  );
};

export default CarbonlessAdhesive;
